<template>
    <div class="guide">
        <div class="guide_header" v-if="headerShow ===1">
            <div></div>
            <p>旅行社解绑列表</p>
            <p @click="showSerch">
                <img src="../../../../assets/image/search.png" alt="">
            </p>
        </div>
        <div class="search" v-if="headerShow1 ===2">
            <img src="../../../../assets/index/icon_white copy.png" alt="" class="search_img1" @click="goBack">
            <input type="text" class="search_key" placeholder="请输入旅行社名称" v-model="searchkey" />
            <span class="search_btn" @click="startSearch">查询</span>
            <img src="../../../../assets/image/search.png" class="search_img" />
        </div>
        <div class="guide_header" v-if="headerShow === 3">
            <div class="header_input" @click="showCity">
                <p>{{title_text}}</p>
                <p class="way_cs"></p>
            </div>
            <div class="header_text">查询</div>
        </div>
        <div class="guide_list">
            <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="finishedText"
                @load="onLoad"
                class="list_wrapper"
            >
                <div
                    class="list"
                    v-for="(t,index) in guideList"
                    :key="index"
                    >
                    <div class="list_item">
                        <div class="item_info1">
                            <p>
                                <span>序号：{{index+1}}</span><span></span>
                            </p>
                            <p>
                                <van-checkbox v-model="t.Check" shape="square"  @change="changebox(t,t.Check)" checked-color="#07c160"></van-checkbox>
                            </p>
                        </div>
                        <div class="item_info">
                            <p>旅行社名称：</p>
                            <p>{{t.name}}</p>
                        </div>
                        <div class="item_info">
                            <p>绑定人：</p>
                            <p>{{t.operator}}</p>
                        </div>
                        <div class="item_info">
                            <p>绑定时间：</p>
                            <p>{{t.time}}</p>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
        <div class="guide_buttom">
            <div class="guide_btn"  @click="addInfo">解绑旅行社</div>
        </div>
        <common-picker ref="commonPicker1" :typeList="typeList1" :cols="cols1" @getTypeValue="getCityValue"></common-picker>

    </div>
</template>
<script>
    import api from '../../../../service/modules/complaint';
    import commonPicker from '../../../../components/base/commonPicker';
    import { timeType } from '../../../../utils/configJson';
    import util from '@/utils/common'
    export default {
        components: {
            commonPicker
        },
        data () {
            return {
                loading: false,
                finished: false,
                finishedText: '没有更多',
                pageIndex: '0',
                guideList: [],
                btnShow: false,
                headerShow: 1,
                checked: true,
                cityList: [],
                typeList1: timeType,
                cols1: 2,
                title_text: '选择区域',
                areaId: '',
                searchkey: '', // 搜索的ke值
                headerShow1: 2,
                bindingIdArray: [],
                bindingNameArray: [],
                item: util.getJsonLocal('item')

            }
        },
        mounted () {
            this.$nextTick(() => {
                document.addEventListener('click', this.hide);
            })
            this.getMoreList();
        },
        methods: {
            showSerch () {
                this.headerShow = 0;
                this.headerShow1 = 2;
            },
            goBack () {
                this.headerShow = 1;
                this.headerShow1 = 5;
                this.pageIndex = 0;
                this.getMore();
            },
            hide (e) {
                if (e.target.className === 'item_info') {
                    this.headerShow = 1;
                }
            },
            getCityValue (value) {
                console.log(66, value);
                if (value.length > 1) {
                    this.title_text = value[0].label + '-' + value[1].label;
                    this.areaId = value[1].areaId;
                } else {
                    this.title_text = value[0].label;
                    this.areaId = value[0].areaId;
                }
                // this.getList();
            },
            showCity () {
                this.$refs.commonPicker1.showPicker();
            },
            startSearch () {
                this.pageIndex = 0;
                this.getMoreList();
            },
            getMore () {
                this.pageIndex++;
                api
                    .guideAndTravelList({
                        curPage: this.pageIndex,
                        type: 'boundList',
                        pageSize: 10,
                        orderNo: this.item.main_complain_number,
                        objType: 'travel'
                    })
                    .then(res => {
                        if (res.data.list.length > 0) { // 有数据
                            this.proList = this.guideList.concat(res.data.list);
                            if (this.guideList.length === res.data.totalSize) {
                                this.finished = true;
                                this.loading = false;
                            } else {
                                this.finished = false;
                                this.loading = false;
                            }
                        }
                    });
            },
            onLoad () {
                this.getMore();
            },
            changebox (value, type) {
                this.bindingIdArray.push(value.id);
                this.bindingNameArray.push(value.name)
                if (type === true) {
                    let newArr = [];
                    let newArr1 = [];
                    this.bindingIdArray = this.bindingIdArray.sort(function (a, b) {
                        return a > b
                    }).forEach(function (n) {
                        if (newArr.indexOf(n) === -1) {
                            newArr.push(n)
                        }
                    })
                    this.bindingIdArray = newArr;
                    this.bindingNameArray = this.bindingNameArray.sort(function (a, b) {
                        return a > b
                    }).forEach(function (n) {
                        if (newArr1.indexOf(n) === -1) {
                            newArr1.push(n)
                        }
                    })
                    this.bindingNameArray = newArr1;
                } else {
                    let newArr = [];
                    let newArr1 = [];
                    this.bindingIdArray = this.bindingIdArray.sort(function (a, b) {
                        return a > b
                    }).forEach(function (n) {
                        if (newArr.indexOf(n) === -1) {
                            newArr.push(n)
                        }
                    })
                    this.bindingIdArray = newArr;
                    this.bindingNameArray = this.bindingNameArray.sort(function (a, b) {
                        return a > b
                    }).forEach(function (n) {
                        if (newArr1.indexOf(n) === -1) {
                            newArr1.push(n)
                        }
                    })
                    this.bindingNameArray = newArr1;
                    const number = this.bindingIdArray.indexOf(value.id);
                    if (number > -1) {
                        this.bindingIdArray.splice(number, 1);
                    }
                    const number1 = this.bindingNameArray.indexOf(value.name);
                    if (number > -1) {
                        this.bindingNameArray.splice(number1, 1);
                    }
                }
                console.log('sort', this.bindingIdArray)

                console.log('bindingIdArray', this.bindingIdArray)
            },
            getMoreList () {
                this.pageIndex++;
                api
                    .guideAndTravelList({
                        curPage: this.pageIndex,
                        type: 'boundList',
                        pageSize: 10,
                        name: this.searchkey,
                        orderNo: this.item.main_complain_number,
                        objType: 'travel'
                    })
                    .then(res => {
                        if (res.data.list.length === 0) {
                            this.isNolist = true;
                            if (this.isNolist === true) {
                                this.finishedText = '';
                            }
                            this.finished = true;
                            this.loading = false;
                        } else if (res.data.list.length === res.data.totalSize) {
                            this.isNolist = false;
                            this.loading = false;
                            this.finished = true;
                        } else {
                            this.loading = false;
                            this.finished = false;
                        }
                        this.guideList = res.data.list;
                    });
            },
            addInfo () {
                api
                    .guideAndTravelOperation({
                        type: 'remove',
                        main_complain_number: this.item.main_complain_number,
                        complain_number: this.item.complain_number,
                        sub_id: this.item.sub_id,
                        objType: 'travel',
                        unBindingIdArray: this.bindingIdArray,
                        unBindingNameArray: this.bindingNameArray
                    })
                    .then(res => {
                        // this.$router.push({
                        //     path: '/complaint/detailList/complaintSheet',
                        //     query: { item: this.item, type: 'boundList' }
                        // })
                        this.$router.back();
                    });
            }
        }
    }
</script>
<style lang="less" scoped>
.guide {
    background: #fbfbfb;
    height: 100%;
    .guide_header {
        width: 100%;
        height: 50px;
        background: #fff;
        position: fixed;
        top: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 5px;
        z-index: 90;
        p>img {
            width: 20px;
            height: 20px;
        }
        p:nth-child(2) {
            font-size: 20px;
        }

        .header_input {
            display: flex;
            justify-content: space-between;
            width: 88%;
            align-items: center;
            .way_cs {
                width: 0px;
                height: 0px;
                border: 5px solid transparent;
                border-top: 7px solid #118BF5;
            }
            p {
                font-size: 18px;
                color: #999999;
            }
        }
        .header_text {
            font-size: 18px;
            color: #118bf5;
        }
    }
    .search {
        width: 100%;
        position: fixed;
        top: 0px;
        background: #fff;
        margin-top: 7px;
        p {
            text-align: center;
        }
        .search_key {
            width: 275px;
            height: 36px;
            background: #f8f8f8;
            border-radius: 18px;
            margin-left: 40px;
            font-size: 13px !important;
            padding-left: 39px;
            box-sizing: border-box;
            border: 0;
            outline: none;
            line-height: 36px;
        }
        .search_btn {
            font-size: 14px;
            margin-left: 16px;
        }
        .search_img {
            width: 15px;
            height: 14px;
            position: absolute;
            left: 50px;
            top: 11px;
        }
        .search_img1 {
            width: 15px;
            height: 14px;
            position: absolute;
            left: 15px;
            top: 11px;
        }
    }
    .travel_city {
        position: absolute;
        top: 0;
        margin-top: 20px;
        ul {
            list-style:none
        }
    }
    .guide_list {
        margin-top: 50px;
        margin-bottom: 60px;
        .list_wrapper {

        }
        .list {
            width: 100%;
            padding-top: 10px;
            .list_item {
                margin: 20px 15px 0 15px;
                box-sizing: border-box;
                background-color: #fff;
                padding: 16px;
                box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
                .item_info {
                    display: flex;
                    font-size: 14px;
                    p {
                        padding: 5px 0px;
                    }
                }
                .item_info1 {
                    display: flex;
                    justify-content: space-between;
                    font-size: 14px;
                    p {
                        padding: 5px 0px;
                    }
                    p:nth-child(2) {
                        .van-checkbox {
                            .van-checkbox__icon .van-checkbox__icon--square {
                                font-size: 0px;
                            }
                        }
                    }
                }
            }
        }
    }
    .guide_buttom {
        width: 100%;
        height: 50px;
        background: #fff;
        position: fixed;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 99;
        .guide_btn {
            background: #36B374;
            color: #fff;
            font-size: 14px;
            height: 40px;
            width: 93%;
            border-radius: 5px;
            text-align: center;
            line-height: 40px;
        }
    }
}
</style>
